<template>
  <div class="introduce" v-if="showPage">
    <!-- <div class="article-c" v-html="text"></div> -->
    <div class="login-kv"></div>
    <van-cell-group inset class="list">
      <van-cell
        class="list-cell"
        v-for="(item, index) in list"
        :key="index"
        @click="gonext(item)"
      >
        <template #title>
          <van-image width="70" height="70" :src="item.image" fit="contain" />
          <div class="text">
            <p class="van-multi-ellipsis--l2 title" v-html="item.title"></p>
            <p class="van-multi-ellipsis--l2 grey" v-html="item.summary"></p>
          </div>
        </template> </van-cell
    ></van-cell-group>

    <div class="article-btn btn">
      <van-button type="info" block round @click="goback" color="#0AA8AF"
        >返回</van-button
      >
    </div>
  </div>
</template>

<script>
var jweixin = require("jweixin-module");
import { pageInfo, articles } from "../../api/api";
export default {
  data() {
    return {
      // text:'',
      list: [],
      showPage:false,
    };
  },
  mounted() {
    this.getlist();
  },
  methods: {
    async getlist() {
      await articles({
        params: {
          "ArticleSearch[column_id]": "62", //项目菜单
          sort: "sortnum desc",
        },
      }).then((res) => {
        console.log(res.data);
        this.list = res.data.items;
        this.showPage=true;
      });
    },
    goback() {
      this.$wechat.closeWindow();
    },
    gonext(item) {
      this.$router.push({
        name: "IntroduceDetail",
        query: {
          id: item.id,
          column_id: this.column_id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.introduce {
  height: 100%;
  width: 100%;
  padding-bottom: 70px;
  box-sizing: border-box;
  .login-kv {
    min-height: 150px;
    width: 100%;
    margin-bottom: 15px;
    background: url(../../assets/login_banner.png);
    background-size: cover;
    background-position: center;
    img {
      height: 100%;
      width: 100%;
    }
  }
  .list {
    border-radius: 9px;
    box-shadow: 0px 2px 11px 0px #27444915;
    margin: 15px;
    .list-cell {
      border-radius: 9px;
      .van-cell__title {
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }

      .text {
        .title {
          font-size: 17px;
        }
        .grey {
          font-size: 14px;
          color: #808080;
        }
      }
    }
  }

  .btn {
    position: fixed;
    bottom: 0;
    left: 0;
    // background: #F7F8FF ;
    z-index: 99;
    padding: 20px;
    box-sizing: border-box;
  }
}
</style>